import {z} from 'zod';

const bytes = z.number().int().nonnegative().safe();
const reading = z.number().finite().nonnegative().nullable();
const vm = z.object({
  accountId: z.uuid(), state: z.enum(['running', 'starting', 'paused', 'stopping', 'stopped', 'crashed', 'unavailable']),
  retired: z.boolean(), vcpus: z.number().int().positive(), cpuCoresUsed: reading,
  memoryAssignedBytes: bytes, memoryResidentBytes: bytes.nullable(), memoryGuestUsedBytes: bytes.nullable(),
  memorySampleAgeSeconds: reading, hostDiskAllocatedBytes: bytes,
  storage: z.object({limitBytes: bytes, usedBytes: bytes, availableBytes: bytes, totalBytes: bytes}).strict().nullable(),
  storageError: z.string().nullable(), networkReceiveBytesPerSecond: reading, networkSendBytesPerSecond: reading,
  diskReadBytesPerSecond: reading, diskWriteBytesPerSecond: reading,
}).strict();
export const VmResourceInventorySchema = z.object({
  observedAt: z.iso.datetime(), sampleSeconds: z.number().positive(),
  host: z.object({cpuCount: z.number().int().positive(), cpuPercent: reading,
    memoryTotalBytes: bytes, memoryAvailableBytes: bytes, swapUsedBytes: bytes,
    runningMemoryAssignedBytes: bytes, diskTotalBytes: bytes, diskAvailableBytes: bytes}).strict(),
  accounts: z.array(vm),
}).strict();
export const AdminVirtualMachinesSchema = VmResourceInventorySchema.extend({
  accounts: z.array(vm.extend({username: z.string().nullable(), email: z.string().nullable()})),
});
export type VmResourceInventory = z.infer<typeof VmResourceInventorySchema>;
export type AdminVirtualMachines = z.infer<typeof AdminVirtualMachinesSchema>;
